<script>
  import { titleCase } from "../helpers.js";
  import { searchParamsStore } from "../stores.js";

  export let type;
  export let value;
  export let displayText = titleCase(value);

  const storeType = {
    subjectType: "types",
    srs: "srs",
    partOfSpeech: "partsOfSpeech"
  }[type];

  function handleChange(event) {
    if (event.target.checked) return addSearchParam(value);
    return removeSearchParam(value);
  }

  function addSearchParam(param) {
    searchParamsStore.update(store => {
      store[storeType].push(param);
      return store;
    });
  }

  function removeSearchParam(param) {
    searchParamsStore.update(store => {
      const activeParams = store[storeType];
      activeParams.splice(activeParams.indexOf(param), 1);
      return store;
    });
  }
</script>

<style>
  input {
    margin-left: 0.15rem;
    margin-right: 0.5rem;
    margin-bottom: 0.75rem;
  }
</style>

<label>
  <input type="checkbox" {value} on:change={event => handleChange(event)} />
  {displayText}
</label>
